<template>
  <div id="page-ride-report">
    <el-form
      class="search-form"
      ref="searchForm"
      :inline="true"
      :model="searchForm"
      label-width="6em"
    >
      <el-row>
        <el-form-item prop="regionId" label="Region" required>
          <filter-businessline-region :value.sync="searchForm.regionId" businessLine="2" required />
        </el-form-item>
        <el-form-item label="时间" required>
          <el-date-picker
            v-model="searchForm.date"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" @click="fetchData(true)" :loading="isLoading">查询</el-button>
          <el-button
            @click="exportSearchData"
            :loading="exportLoading"
            :disabled="dataList.length === 0"
            >导出</el-button
          >
        </el-form-item>
      </el-row>
    </el-form>
    <!-- 列表 -->
    <el-table stripe :data="dataList" v-loading="isLoading">
      <el-table-column
        v-for="(item, index) in rideTableList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
      />
    </el-table>
    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        background
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination'
import qs from 'qs'
import { rideTable } from './table'

export default {
  mixins: [pagination],

  data() {
    return {
      isLoading: false,
      exportLoading: false,
      dataList: [],
      dateRange: [],
      rideTableList: rideTable,
      cacheParams: {},
      searchForm: {
        regionId: '',
        date: '',
      },
    }
  },

  created() {
    this.initPagination('fetchData', false)
  },

  mounted() {
    this.searchForm.date = this.timeDefault
  },

  computed: {
    timeDefault() {
      const before = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
      const s1 = this.associateUtils && this.associateUtils.dateFormat(before)
      return s1
    },
  },

  methods: {
    // 列表
    fetchData(init = false) {
      if (init) this.pageNo = 1
      const params = {
        ...this.searchForm,
        pageSize: this.pageSize,
        pageNumber: this.pageNo,
      }
      this.cacheParams = {
        regionId: this.searchForm.regionId,
        date: this.searchForm.date,
      }
      this.isLoading = true
      this.fetch
        .get('getSpockDailyReport', { params })
        .then(res => {
          const { list = [], total = 0 } = res.data || {}
          this.isLoading = false
          this.dataList = list
          this.totalAmount = total
        })
        .catch(() => {
          this.dataList = []
          this.isLoading = false
        })
    },

    // 导出
    exportSearchData() {
      const params = {
        ...this.cacheParams,
      }
      this.exportLoading = true
      this.fetch
        .post('settlementDetailExport', qs.stringify(params))
        .then(res => {
          this.exportLoading = false
          if (res.data) {
            window.downloadFile(res.data)
          } else {
            this.$message.error('数据错误，请重试')
          }
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
  },
}
</script>
